/*
 * Manifest of ported /x endpoints — the webApp projection of the canonical contract
 * (inistate-api: contract/x-endpoints.json, served dev-only at GET /x-manifest).
 * ONLY xClient.js may import this. Stores call xCall(key, ...) by key, never by path.
 * Kept in sync with the canonical by P4's drift gate.
 */
export const X_ENDPOINTS = {
  form:      { xPath: '/x/form',      legacyPath: '/api/activity/form',          policy: 'gated',            method: 'post' },
  list:      { xPath: '/x/list',      legacyPath: '/api/workspace/list',         policy: 'gated',            method: 'post' },
  select:    { xPath: '/x/select',    legacyPath: '/api/activity/formselection', policy: 'gated',            method: 'post' },
  // Deliberately ungated: always tries /x, relies solely on the 501 fallback. Sole such case (SS06012).
  workspace: { xPath: '/x/workspace', legacyPath: '/api/workspace',              policy: 'always-x-501only', method: 'get'  },
};

export const X_POLICIES = ['gated', 'always-x-501only'];

/**
 * Pure well-formedness check for a single X_ENDPOINTS entry. Co-located with the manifest so both
 * the real entries and negative/malformed test cases exercise the same logic.
 */
export function isWellFormedEntry(entry) {
  return Boolean(
    entry
    && typeof entry.xPath === 'string' && entry.xPath.startsWith('/x/')
    && typeof entry.legacyPath === 'string' && entry.legacyPath.startsWith('/api/')
    && X_POLICIES.includes(entry.policy)
    && ['get', 'post'].includes(entry.method)
  );
}
